import { render, staticRenderFns } from "./create-customer-modal.vue?vue&type=template&id=f23a3dd8&lang=pug"
import script from "./create-customer-modal.vue?vue&type=script&lang=js"
export * from "./create-customer-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports